import { compareItemsLSKey } from '../../../configuration/index.js';

/**
 * Write compare items to local storage
 *
 * @param {Object} param0
 * @param {CompareItem[]} param0.items
 */
export default function setCompareItems({ items }) {
  localStorage.setItem(
    compareItemsLSKey,
    JSON.stringify({
      items: items
        // Store only prid and catalog (important for always get the same value)
        .map(({ prid, catalog, type }) => ({ prid: String(prid), catalog: String(catalog), type: String(type) }))
    })
  );
}
